import InputClearAction from './input-clear-action';

export default InputClearAction;
